import {combineReducers} from 'redux';
import jezikReducer from './jezik/jezik.reducer';

export default combineReducers({
        jezik: jezikReducer
});
